export class JsonUtil {
    static parse<T>(value: string, checkTypeCallback: (a: any) => boolean, defaultValue: T = null): T {
        try {
            const result = JSON.parse(value);

            if (checkTypeCallback(result)) {
                return result as T;
            }

            throw new Error('Type error');
        } catch (e) {
            return defaultValue;
        }
    }
}
